import { create } from "zustand"

type State = {
  isStaleVersion: boolean
}

type Actions = {
  markStale: () => void
}

const initialState: State = {
  isStaleVersion: false,
}

export const useVersionStore = create<State & Actions>((set) => ({
  ...initialState,
  markStale: () => set({ isStaleVersion: true }),
}))
